import { render, staticRenderFns } from "./ListActionComp.vue?vue&type=template&id=908b6304&scoped=true&"
import script from "./ListActionComp.vue?vue&type=script&lang=ts&"
export * from "./ListActionComp.vue?vue&type=script&lang=ts&"
import style0 from "./ListActionComp.vue?vue&type=style&index=0&id=908b6304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908b6304",
  null
  
)

export default component.exports